<template>
  <div class="coupon">
    <form
      :class="[
        'coupon-code',
        {
          'coupon-code--closed': !appliedCoupon,
          'coupon-code--opened': appliedCoupon,
          apply: appliedCoupon,
        },
      ]"
      @submit="applyCoupon"
    >
      <a
        v-if="!isNewCart"
        class="coupon-code__toggle"
        rel="nofollow"
        @click.prevent="couponToggle"
      >
        {{ $t('cart.coupon_code.apply_discount') }}
      </a>
      <div class="coupon-code__fields-apply">
        <input
          v-model="couponCode"
          type="text"
          name="coupon_code"
          class="coupon-code__input"
          :placeholder="$t('cart.coupon_code.title')"
        />
        <v-button
          type="submit"
          :label="$t('cart.coupon_code.apply')"
          class="coupon-code__btn-apply"
          height="44px"
          :loading="calculating"
        />
      </div>
    </form>
  </div>
</template>

<script>
import appendUrlParam from '~/utils/appendUrlParam'
import VButton from '~/components/v-button/VButton.vue'

export default {
  name: 'CouponCode',
  components: {
    VButton,
  },
  props: {
    isNewCart: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      appliedCoupon: this.isNewCart,
      couponCode: '',
      calculating: false,
    }
  },
  methods: {
    couponToggle() {
      this.appliedCoupon = !this.appliedCoupon
    },
    async applyCoupon(e) {
      if (this.calculating) return
      e.preventDefault()

      if (!this.couponCode) {
        this.$displayTopMessage(this.$t('cart.coupon_code.empty'), {
          type: 'error',
        })
        return
      }

      this.calculating = true

      const params = {
        ...this.$store.getters.storeInfo,
      }

      try {
        const result = await this.$apiv2.$post(
          appendUrlParam('coupons/apply', params),
          {
            coupon_code: this.couponCode,
          }
        )
        this.$displayTopMessage(result.message)
        this.$emit('updateCart', result.cart)
      } catch (err) {
        const errorMessage = err?.response?.data?.message
        this.$displayTopMessage(errorMessage, {
          type: 'error',
        })
      } finally {
        this.calculating = false
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.coupon {
  width: 100%;

  @media (max-width: $v4_tablet) {
    margin-left: -15px;
    margin-right: -15px;
    width: auto;
  }
}
.coupon-code {
  padding: 0 15px;
  width: 100%;
  box-sizing: border-box;
}

.coupon-code__toggle {
  display: block;
  margin: 0;
  font-size: 15px;
  line-height: 18px;
  color: #555;
  text-decoration: none;
  text-align: right;

  &:hover {
    color: #a2a2a6;
  }

  &::before {
    content: '+';
    margin-right: 2px;
  }
}
.coupon-code__toggle .icon {
  margin-right: 2px;
}

.coupon-code--closed {
  & .coupon-code__fields-apply {
    display: none;
  }
  & .coupon-code__fields-remove {
    display: none;
  }
  & .close {
    display: none;
  }
  & .open {
    display: inline-block;
  }

  .coupon-code__toggle::before {
    content: '+';
  }
}
.coupon-code--opened {
  & .coupon-code__fields-apply {
    display: flex;
    margin-top: $v4_gutter;
  }
  & .coupon-code__fields-remove {
    display: none;
  }
  & .close {
    display: inline-block;
  }
  & .open {
    display: none;
  }

  .coupon-code__toggle::before {
    content: '-';
  }
}

.coupon-code {
  @media (max-width: $v4_tablet) {
    margin-top: 5 * $v4_gutter;
  }
}

.coupon-code__fields {
  margin-top: 10px;
  text-align: left;
  display: flex;
}
.coupon-code__input[type='text'] {
  line-height: normal;
  width: 100%;
  font-size: 13px;
  border-radius: 0;
  border-top-left-radius: 4px;
  border-bottom-left-radius: 4px;
}

.coupon-code__btn-apply {
  min-width: 100px;
  display: flex;
  align-items: center;
  justify-content: center;
}

@media (min-width: $screen_large) {
  .coupon-code {
    margin-top: 0;
  }
}
</style>
